import { connect } from 'react-redux'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
import PopularAreasSearch from './PopularAreasSearch'


export default connect(
  () => ({}),
  { googleAnalyticsEvent },
)(PopularAreasSearch)
